import { cn } from "@homeinstead/ui";
import HalfStarSVG from "./half-star.svg";

export interface HalfStarProps {
  className?: string;
}

const HalfStar = ({ className }: HalfStarProps) => (
  <HalfStarSVG
    aria-label="Half-star"
    className={cn("fill-new-beginnings-base", className)}
  />
);

export default HalfStar;
